import styles from './MessagesList.module.css';
import Message from '../Message/Message';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { useEffect, useMemo, useRef } from 'react';

import { motion } from 'motion/react';

import confetti from '../../assets/video/confetti.webm';

const MessagesList = ({
  messages,
  authorFontSize,
  currentState,
  winId,
  speed,
}) => {
  const confettiRef = useRef(null);

  const isWinner = useMemo(() => currentState === 'S5', [currentState]);

  useEffect(() => {
    let idTimeout = '';
    if (confettiRef.current && isWinner) {
      idTimeout = setTimeout(() => {
        confettiRef.current.play().catch((error) => {});
      }, 1500);
    } else if (idTimeout) {
      clearTimeout(idTimeout);
    }
    return () => {
      clearTimeout(idTimeout);
    };
  }, [isWinner]);

  const letters = 'ПОБЕДИТЕЛЬ!'.split('').reverse();

  return (
    <div className={styles['wrapper']}>
      <div className={styles.firstLine} dir="rtl">
        {isWinner &&
          letters.map((l, idx, arr) => {
            let initialIdx = 3;
            let oneLetterWidth = 9;
            let initialX = `${(idx - initialIdx) * oneLetterWidth}rem`;

            return (
              <motion.div
                style={{ position: 'relative', zIndex: idx * -1 }}
                key={l + idx}
                initial={{
                  scale: 0,
                  x: initialX,
                }}
                animate={{
                  scale: 1,
                  x: 0,
                }}
                transition={{
                  duration: 0.4,
                  delay: idx * 0.1 + 2,
                }}
              >
                {l}
              </motion.div>
            );
          })}
      </div>

      {currentState &&
        (currentState === 'S3' ||
          currentState === 'S4' ||
          (currentState === 'S5' && messages.length >= 2)) && (
          <div className={styles['messagesWrapper']}>
            <TransitionGroup className={styles['messages']} appear={true}>
              {messages.length > 0 &&
                messages.map((item, i) => (
                  <CSSTransition
                    key={item.UUID}
                    timeout={speed}
                    classNames="position"
                  >
                    <Message
                      winId={winId}
                      key={item.id}
                      message={item.message}
                      authorFontSize={authorFontSize}
                      currentState={currentState}
                    />
                  </CSSTransition>
                ))}
            </TransitionGroup>
          </div>
        )}

      {isWinner && (
        <video
          ref={confettiRef}
          muted="muted"
          loop
          playsInline
          className={styles.confetti}
        >
          <source src={confetti} type="video/webm"></source>
        </video>
      )}
    </div>
  );
};

export default MessagesList;
